// src/admin/lib/adminAuth.js
// Deliberately separate from lib/auth.js (merchant sessions). A different
// localStorage key means an admin can be logged into the admin panel and
// a merchant account in the same browser without either session clobbering
// the other -- useful since you'll often be testing both at once.

const KEY = "cdm_admin_session";

export function setAdminSession(token, email, role) {
  localStorage.setItem(KEY, JSON.stringify({ token, email, role }));
}

export function getAdminSession() {
  try {
    const s = localStorage.getItem(KEY);
    return s ? JSON.parse(s) : null;
  } catch {
    return null;
  }
}

export function getAdminSessionToken() {
  return getAdminSession()?.token || null;
}

export function clearAdminSession() {
  localStorage.removeItem(KEY);
}
